<template>
  <div class="col-12 col-lg-6 col-xl-8">
    <div class="row">
      <div class="col-12 col-xl-6">
        <validation-provider
          tag="div"
          :name="$t('form.labels.businessType')"
          rules="required"
          mode="passive"
          v-slot="{ errors }"
        >
          <ui-select
            v-model="form.type"
            :items="types"
            :label="$t('form.labels.businessType')"
            :placeholder="$t('form.placeholders.select')"
            label-key="label"
            value-key="value"
            filterable
            required
            :error="errors[0]"
            :disabled="!editable"
          />
        </validation-provider>

        <template v-if="form.type">
          <validation-provider
            v-if="showMasterLocationSelect"
            tag="div"
            :name="$t('form.labels.locationRole')"
            rules="required"
            mode="passive"
            v-slot="{ errors }"
          >
            <ui-select
              v-model="form.isMasterLocation"
              :items="roleTypes"
              :label="$t('form.labels.locationRole')"
              :placeholder="$t('form.placeholders.select')"
              label-key="label"
              value-key="value"
              filterable
              required
              :error="errors[0]"
              :disabled="!editable"
            />
          </validation-provider>

          <validation-provider
            v-if="!isMasterLocation"
            tag="div"
            :name="$t('form.labels.processingMethod')"
            rules="required"
            mode="passive"
            v-slot="{ errors }"
          >
            <ui-select
              v-model="form.processingMethod"
              :items="processingMethodList"
              :label="$t('form.labels.processingMethod')"
              :placeholder="$t('form.placeholders.select')"
              label-key="label"
              value-key="value"
              filterable
              required
              :error="errors[0]"
              :disabled="!editable"
            />
          </validation-provider>

          <template v-if="!isMasterLocation">
            <validation-provider
              tag="div"
              :name="$t('form.labels.tipCollectionType')"
              rules="required"
              mode="passive"
              v-slot="{ errors }"
            >
              <ui-select
                v-model="form.tipsType"
                :items="tipsTypes"
                :label="$t('form.labels.tipCollectionType')"
                :placeholder="$t('form.placeholders.select')"
                label-key="label"
                value-key="value"
                filterable
                required
                :error="errors[0]"
                :disabled="!editable"
              />
            </validation-provider>

            <validation-provider
              v-if="showPaymentSystem"
              tag="div"
              :name="$t('form.labels.paymentSystem')"
              rules="required"
              mode="passive"
              v-slot="{ errors }"
            >
              <ui-select
                v-model="form.paymentSystem"
                :items="paymentSystems"
                :label="$t('form.labels.paymentSystem')"
                :placeholder="$t('form.placeholders.select')"
                label-key="label"
                value-key="value"
                filterable
                required
                :error="errors[0]"
                :disabled="!isSupportAdminEditable"
              />
            </validation-provider>

            <validation-provider
              v-if="showTaxReportingType"
              tag="div"
              :name="$t('form.labels.taxReportingType')"
              rules="required"
              mode="passive"
              v-slot="{ errors }"
            >
              <ui-select
                v-model="form.taxReportingType"
                :items="taxReportingTypes"
                :label="$t('form.labels.taxReportingType')"
                :placeholder="$t('form.placeholders.select')"
                label-key="label"
                value-key="value"
                filterable
                required
                :error="errors[0]"
                :disabled="!editable"
              />
            </validation-provider>

            <validation-provider
              v-if="showTaxesSelect"
              tag="div"
              :name="$t('form.labels.taxes')"
              mode="passive"
              :rules="taxesValidationRules"
              v-slot="{ errors }"
            >
              <ui-select
                v-model="form.taxes"
                :items="taxTypes"
                :label="$t('form.labels.taxes')"
                :placeholder="$t('form.placeholders.select')"
                label-key="label"
                value-key="value"
                filterable
                :error="errors[0]"
                :disabled="isTaxesDisabled"
                :required="isTaxesRequired"
              />
            </validation-provider>

            <validation-provider
              v-if="showTipPayoutType"
              tag="div"
              :name="$t('form.labels.tipPayoutType')"
              rules="required"
              mode="passive"
              v-slot="{ errors }"
            >
              <ui-select
                v-model="form.tipPayoutType"
                :items="tipPayoutTypeList"
                :label="$t('form.labels.tipPayoutType')"
                :placeholder="$t('form.placeholders.select')"
                label-key="label"
                value-key="value"
                filterable
                required
                :error="errors[0]"
                :disabled="!editable"
              />
            </validation-provider>

            <validation-provider
              v-if="showCaseType"
              tag="div"
              :name="$t('form.labels.case')"
              rules="required"
              mode="passive"
              v-slot="{ errors }"
            >
              <ui-select
                v-model="form.caseType"
                :items="caseTypes"
                :label="$t('form.labels.case')"
                :placeholder="$t('form.placeholders.select')"
                label-key="label"
                value-key="value"
                filterable
                required
                :error="errors[0]"
                :disabled="!isSupportAdminEditable"
              />
            </validation-provider>

            <validation-provider
              v-if="showPayoutMethod"
              tag="div"
              :name="$t('form.labels.payoutMethod')"
              rules="required"
              mode="passive"
              v-slot="{ errors }"
            >
              <ui-select
                v-model="form.payoutMethod"
                :items="payoutMethodList"
                :label="$t('form.labels.payoutMethod')"
                :placeholder="$t('form.placeholders.select')"
                label-key="label"
                value-key="value"
                filterable
                required
                :error="errors[0]"
                :disabled="!editable"
              />
            </validation-provider>

            <validation-provider
              v-if="showPayoutDestination"
              tag="div"
              :name="$t('form.labels.payoutDestination')"
              rules="required"
              mode="passive"
              v-slot="{ errors }"
            >
              <ui-select
                v-model="form.payoutDestination"
                :items="payoutDestinationList"
                :label="$t('form.labels.payoutDestination')"
                :placeholder="$t('form.placeholders.select')"
                label-key="label"
                value-key="value"
                filterable
                required
                :error="errors[0]"
                :disabled="!editable"
              />
            </validation-provider>

            <validation-provider
              v-if="showPaymentPage"
              tag="div"
              :name="$t('form.labels.mainLandingPage')"
              rules="required"
              mode="passive"
              v-slot="{ errors }"
            >
              <ui-select
                v-model="form.paymentPage"
                :items="paymentPages"
                :label="$t('form.labels.mainLandingPage')"
                :placeholder="$t('form.placeholders.select')"
                label-key="label"
                value-key="value"
                filterable
                required
                :error="errors[0]"
              />
            </validation-provider>

            <validation-provider
              v-if="showVenue"
              tag="div"
              :name="$t('form.labels.venueCharge')"
              :rules="venueDisabled ? {} : 'required|decimal|min_value:0|max_value:100'"
              mode="passive"
              v-slot="{ errors }"
            >
              <ui-input
                v-model="form.workplaceFee"
                :label="$t('form.labels.venueCharge')"
                :required="!venueDisabled"
                :disabled="venueDisabled"
                :error="errors[0]"
              />
            </validation-provider>

            <template v-if="showTipout">
              <validation-provider
                tag="div"
                :name="$t('form.labels.tipOut')"
                :rules="{ required: !primaryStaffDisabled }"
                mode="passive"
                v-slot="{ errors }"
              >
                <ui-select
                  v-model="form.primaryStaff"
                  :items="staffTypes"
                  :label="$t('form.labels.tipOut')"
                  :placeholder="$t('form.placeholders.select')"
                  label-key="name"
                  value-key="value"
                  filterable
                  :required="!primaryStaffDisabled"
                  :disabled="primaryStaffDisabled"
                  :error="errors[0]"
                />
              </validation-provider>

              <validation-provider
                tag="div"
                :name="$t('form.labels.tipOutAmount')"
                :rules="primaryStaffDisabled ? {} : 'required|decimal|min_value:1|max_value:100'"
                mode="passive"
                v-slot="{ errors }"
              >
                <ui-input
                  v-model="form.primaryTipout"
                  :label="$t('form.labels.tipOutAmount')"
                  :required="!primaryStaffDisabled"
                  :disabled="primaryStaffDisabled"
                  :error="errors[0]"
                />
              </validation-provider>
            </template>

            <validation-provider
              v-if="showTimeSheet"
              tag="div"
              rules="required"
              :name="$t('form.labels.timeSheet')"
              mode="passive"
              v-slot="{ errors }"
            >
              <ui-select
                v-model="form.timesheetType"
                :items="timeTypes"
                :label="$t('form.labels.timeSheet')"
                :placeholder="$t('form.placeholders.select')"
                label-key="label"
                value-key="value"
                :error="errors[0]"
                :disabled="!editable"
                required
              />
            </validation-provider>

            <ui-select
              v-if="showAbVariant"
              v-model="form.abVariant"
              :items="abVariants"
              label="A/B Variants"
              :placeholder="$t('form.placeholders.select')"
              label-key="label"
              value-key="value"
            />

            <validation-provider
              v-if="showStaffSortingMethod"
              tag="div"
              rules="required"
              :name="$t('form.labels.staffSortingMethod')"
              mode="passive"
              v-slot="{ errors }"
            >
              <ui-select
                v-model="form.staffSortingMethod"
                :items="STAFF_SORTING_METHODS"
                :label="$t('form.labels.staffSortingMethod')"
                :label-info="$t('staffSortingMethod.tooltip')"
                :placeholder="$t('form.placeholders.select')"
                :error="errors[0]"
                required
              />
            </validation-provider>

            <location-type-review
              :form="form"
            />

            <validation-provider
              v-if="showMultipleTipsSwitcher"
              tag="div"
              :name="$t('form.labels.multipleTips')"
              mode="passive"
              v-slot="{ errors }"
            >
              <ui-select
                v-model="form.multiTipsMode"
                :items="MULTI_TIPS_MODES"
                :label="$t('form.labels.multipleTips')"
                :placeholder="$t('form.placeholders.select')"
                :error="errors[0]"
              />
            </validation-provider>

            <location-groups
              v-if="showGroups"
              :location="form"
              :groups="form.groups"
              @update:groups="handleUpdateGroups"
            />
          </template>
          <template v-else>
            <location-sublocations
              :location="form"
              :sublocations="form.sublocations"
              @update:sublocations="handleSublocationsUpdate"
            />
          </template>
        </template>
      </div>

      <location-dashboard-access
        :form="form"
        :data="data"
        :is-onboarding-loading="isOnboardingLoading"
        :disabled="!form.type"
        @completed="$emit('completed')"
        @activate="$emit('activate')"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { SWITZERLAND_TYPES, DEFAULT_TYPES } from '@/config/businessTypes';
import { ALL_TAX_REPORTING_TYPES } from '@/config/taxReportingTypes';
import { MULTI_TIPS_MODES } from '@/config/multiTipsModes';
import LocationSublocations from '@/components/Location/LocationSublocations.vue';
import { PAYMENT_PAGE_TYPE } from '@/config/paymentPageType';
import { PROCESSING_METHOD } from '@/config/processingMethod';
import { PAYOUT_METHOD } from '@/config/payoutMethod';
import { CASE_TYPE } from '@/config/caseType';
import { PAYMENT_SYSTEM, PAYMENT_SYSTEM_LABEL, COUNTRY_DEFAULT_PAYMENT_SYSTEM } from '@/config/paymentSystems';
import { STAFF_SORTING_METHODS } from '@/config/staffSortingMethods';
import { AB_VARIANTS_TYPES } from '@/config/abVariantsTypes';
import { PAYOUT_DESTINATION } from '@/config/payoutDestination';
import LocationGroups from './LocationGroups.vue';
import LocationDashboardAccess from './LocationDashboardAccess.vue';
import LocationTypeReview from './LocationTypeReview.vue';

export default {

  components: {
    LocationSublocations,
    LocationGroups,
    LocationDashboardAccess,
    LocationTypeReview,
  },

  props: {
    form: {
      type: Object,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
    isOnboardingLoading: Boolean,
    editable: Boolean,
  },

  data() {
    return {
      MULTI_TIPS_MODES,
      STAFF_SORTING_METHODS,
    };
  },

  computed: {
    ...mapGetters('auth', [
      'isAdmin',
      'isAdminOrSales',
      'isSupportAdmin',
    ]),
    abVariants() {
      return [
        {
          label: 'Design 1 (default)',
          value: AB_VARIANTS_TYPES.DESIGN_ONE,
          disabled: this.form.enableTapToTip,
        },
        {
          label: 'Design 1, Caption',
          value: AB_VARIANTS_TYPES.DESIGN_ONE_CAPTION,
          disabled: this.form.enableTapToTip,
        },
        {
          label: 'Design 2, Button 2',
          value: AB_VARIANTS_TYPES.DESIGN_TWO_BUTTON_TWO,
          disabled: false,
        },
        {
          label: 'Design 2, Button 3',
          value: AB_VARIANTS_TYPES.DESIGN_TWO_BUTTON_THREE,
          disabled: false,
        },
        {
          label: 'Design 2, Button 2, Caption',
          value: AB_VARIANTS_TYPES.DESIGN_TWO_BUTTON_TWO_CAPTION,
          disabled: false,
        },
        {
          label: 'Design 2, Button 3, Caption',
          value: AB_VARIANTS_TYPES.DESIGN_TWO_BUTTON_THREE_CAPTION,
          disabled: false,
        },
      ];
    },
    isClientGateway() {
      return this.form.processingMethod === PROCESSING_METHOD.CLIENT_GATEWAY;
    },
    isTipPayoutEmployer() {
      return this.form.tipPayoutType === 'EMPLOYER';
    },
    isSwitzerland() {
      return this.form?.country === 'ch';
    },
    types() {
      return this.isSwitzerland ? SWITZERLAND_TYPES : DEFAULT_TYPES;
    },
    taxReportingTypes() {
      return ALL_TAX_REPORTING_TYPES.map((item) => ({
        ...item,
        disabled: item.value === 'SELF_REPORTING' && this.isUk && this.isCommon,
      }));
    },
    isNoPaymentGateway() {
      return this.form.processingMethod === PROCESSING_METHOD.NO_PAYMENT_GATEWAY;
    },
    isCase5() {
      return this.form.caseType === CASE_TYPE.CASE_5;
    },
    tipsTypes() {
      return [
        {
          value: 'PERSONAL',
          label: this.$t('tipsTypes.individual'),
          disabled: this.isTrips || this.isNoPaymentGateway,
          visible: true,
        },
        {
          value: 'COMMON',
          label: this.$t('tipsTypes.commonSimple'),
          disabled: this.isSelfReporting && !this.isNoPaymentGateway,
          visible: true,
        },
        {
          value: 'COMMON_PRIORITY',
          label: this.$t('tipsTypes.commonAdvanced'),
          disabled: !this.isNoPaymentGateway
            && (this.isSpaOrSalon
            || this.isSelfReporting
            || this.showMasterLocationSelect
            || this.isUAE
            || this.isCanada
            || this.isSaudiArabia
            || this.isUSA),
          visible: !this.isDenmark,
        },
        {
          value: 'MIXED',
          label: this.$t('tipsTypes.mixed'),
          disabled: false,
          visible: true,
        },
      ].filter(({ visible }) => visible);
    },
    roleTypes() {
      return [
        {
          value: true,
          label: this.$t('roleTypes.masterLocation'),
        },
        {
          value: false,
          label: this.$t('roleTypes.basicLocation'),
        },
      ];
    },
    taxTypes() {
      return [
        {
          value: 'GROSS',
          label: this.$t('taxTypes.gross'),
        },
        {
          value: 'NET',
          label: this.$t('taxTypes.net'),
        },
      ];
    },
    tipPayoutTypeList() {
      return [
        {
          value: 'INDIVIDUAL',
          label: 'Individual',
          visible: true,
        },
        {
          value: 'EMPLOYER',
          label: 'Employer',
          visible: true,
        },
      ].filter((item) => item.visible);
    },
    caseTypes() {
      return [
        {
          value: CASE_TYPE.CASE_1,
          label: 'Case 1 - Collection + Allocation + Personal distribution',
          disabled: this.isStripe || this.isCanada || this.isSaudiArabia,
          visible: !this.isNoPaymentGateway,
        },
        {
          value: CASE_TYPE.CASE_2,
          label: 'Case 2 - Collection + Allocation + Company distribution',
          disabled: this.isStripe || this.isCanada || this.isSaudiArabia,
          visible: !this.isNoPaymentGateway,
        },
        {
          value: CASE_TYPE.CASE_3,
          label: 'Case 3 - Collection + Company distribution',
          disabled: false,
          visible: !this.isNoPaymentGateway,
        },
        {
          value: CASE_TYPE.CASE_4,
          label: 'Case 4 - Allocation + Personal distribution',
          disabled: this.isStripe || this.isCanada || this.isSaudiArabia || this.isUSA,
          visible: !this.isNoPaymentGateway,
        },
        {
          value: CASE_TYPE.CASE_5,
          label: 'Case 5 - Allocation / Virtual Wallet',
          disabled: false,
          visible: this.isUk && (this.isCommon || this.isMixed) && this.isNoPaymentGateway,
        },
      ].filter(({ visible }) => visible);
    },
    paymentSystems() {
      return [
        {
          value: PAYMENT_SYSTEM.STRIPE,
          label: PAYMENT_SYSTEM_LABEL[PAYMENT_SYSTEM.STRIPE],
          visible: this.isUAE || this.isCanada || this.isSaudiArabia || this.isUSA,
          disabled: !this.isCommon,
        },
        {
          value: PAYMENT_SYSTEM.ADYEN,
          label: PAYMENT_SYSTEM_LABEL[PAYMENT_SYSTEM.ADYEN],
          visible: this.isSaudiArabia,
          disabled: false,
        },
        {
          value: PAYMENT_SYSTEM.RYFT,
          label: PAYMENT_SYSTEM_LABEL[PAYMENT_SYSTEM.RYFT],
          visible: this.isUk || this.isGermany || this.isDenmark || this.isUSA || this.isCanada,
          disabled: false,
        },
        {
          value: PAYMENT_SYSTEM.CHECKOUT_UK_DASHBOARD,
          label: PAYMENT_SYSTEM_LABEL[PAYMENT_SYSTEM.CHECKOUT_UK_DASHBOARD],
          visible: !this.isSaudiArabia && !this.isUSA && !this.isDenmark,
          disabled: this.isTipPayoutEmployer,
        },
        {
          value: PAYMENT_SYSTEM.CHECKOUT_UAE,
          label: PAYMENT_SYSTEM_LABEL[PAYMENT_SYSTEM.CHECKOUT_UAE],
          visible: this.isUAE,
          disabled: false,
        },
        {
          value: PAYMENT_SYSTEM.CHECKOUT,
          label: PAYMENT_SYSTEM_LABEL[PAYMENT_SYSTEM.CHECKOUT],
          visible: false,
          disabled: false,
        },
        {
          value: PAYMENT_SYSTEM.PAYER_MAX,
          label: PAYMENT_SYSTEM_LABEL[PAYMENT_SYSTEM.PAYER_MAX],
          visible: this.isUAE || this.isSaudiArabia || this.isUSA,
          disabled: false,
        },
      ].filter((item) => item.visible);
    },
    paymentPages() {
      return [
        {
          value: PAYMENT_PAGE_TYPE.DIRECT,
          label: this.$t('paymentPages.direct'),
          disabled: this.isSpaOrSalon || this.showMasterLocationSelect || this.isMixed,
        },
        {
          value: PAYMENT_PAGE_TYPE.LIST,
          label: this.$t('paymentPages.list'),
          disabled: this.isMixed,
        },
        {
          value: PAYMENT_PAGE_TYPE.GROUPS,
          label: this.$t('paymentPages.groups'),
        },
      ];
    },
    processingMethodList() {
      return [
        {
          value: PROCESSING_METHOD.EASYTIP_LOCAL_GATEWAY,
          label: this.$t('processingMethod.easytipLocalGateway'),
          visible: true,
        },
        {
          value: PROCESSING_METHOD.CLIENT_GATEWAY,
          label: this.$t('processingMethod.clientGateway'),
          visible: true,
        },
        {
          value: PROCESSING_METHOD.NO_PAYMENT_GATEWAY,
          label: this.$t('processingMethod.noPaymentGateway'),
          visible: this.isUk,
        },
      ].filter(({ visible }) => visible);
    },
    payoutMethodList() {
      return [
        {
          value: PAYOUT_METHOD.LOCAL,
          label: this.$t('payoutMethod.local'),
        },
        {
          value: PAYOUT_METHOD.INTERNATIONAL_SWIFT,
          label: this.$t('payoutMethod.internationalSwift'),
        },
      ];
    },
    payoutDestinationList() {
      return [
        {
          value: PAYOUT_DESTINATION.INDIVIDUAL,
          label: 'Individual Bank Accounts',
        },
        {
          value: PAYOUT_DESTINATION.BUSINESS,
          label: 'Business Bank Account',
        },
      ];
    },
    timeTypes() {
      return [
        {
          value: 'HOURS',
          label: 'Hours',
        },
        {
          value: 'DAYS',
          label: 'Days',
        },
        {
          value: 'SHIFTS',
          label: 'Shifts',
        },
        {
          value: 'UNITS',
          label: 'Units',
        },
      ];
    },
    staffTypes() {
      return this.$store.getters['handbook/staffTypes']
        .filter(({ types }) => types.includes(this.form.type))
        .filter(({ countries }) => countries.includes(this.form.country));
    },
    venueDisabled() {
      return !this.editable || !this.form.tipsType || this.form.tipsType === 'PERSONAL';
    },
    primaryStaffDisabled() {
      return this.form.tipsType !== 'COMMON_PRIORITY';
    },
    isSelfReporting() {
      return this.form.taxReportingType === 'SELF_REPORTING';
    },
    isCommon() {
      return this.form.tipsType === 'COMMON'
        || this.form.tipsType === 'COMMON_PRIORITY';
    },
    isCommonSimple() {
      return this.form.tipsType === 'COMMON';
    },
    isMixed() {
      return this.form.tipsType === 'MIXED';
    },
    isRyft() {
      return this.form.paymentSystem === PAYMENT_SYSTEM.RYFT;
    },
    isPayerMax() {
      return this.form.paymentSystem === PAYMENT_SYSTEM.PAYER_MAX;
    },
    isStripe() {
      return this.form.paymentSystem === PAYMENT_SYSTEM.STRIPE;
    },
    isCheckoutUkDashboard() {
      return this.form.paymentSystem === PAYMENT_SYSTEM.CHECKOUT_UK_DASHBOARD;
    },
    isCheckoutUAE() {
      return this.form.paymentSystem === PAYMENT_SYSTEM.CHECKOUT_UAE;
    },
    isPersonal() {
      return this.form.tipsType === 'PERSONAL';
    },
    isDirectPaymentPage() {
      return this.form.paymentPage === 'DIRECT';
    },
    showPayoutMethod() {
      return !this.isClientGateway && !this.isNoPaymentGateway;
    },
    showAbVariant() {
      return this.isAdmin && !this.isNoPaymentGateway;
    },
    showMultipleTipsSwitcher() {
      return this.isAdminOrSales
        && this.isPersonal
        && !this.isDirectPaymentPage
        && !this.isTipPayoutEmployer;
    },
    showTipPayoutType() {
      return this.isUAE && this.isCommon && (this.isCheckoutUkDashboard || this.isCheckoutUAE);
    },
    showCaseType() {
      const hasPaymentGateway = this.isRyft || this.isPayerMax || this.isStripe
        || this.isClientGateway || this.isCheckoutUkDashboard;

      const standardFlow = hasPaymentGateway
        && (this.isCommon || this.isMixed)
        && (!this.isCheckoutUkDashboard || !this.isUAE); // filter for UAE + CHECKOUT_UK_DASHBOARD

      const case5Flow = this.isNoPaymentGateway
        && this.isUk
        && (this.isCommon || this.isMixed);

      return standardFlow || case5Flow || this.isCase5;
    },
    showPaymentSystem() {
      return (this.isUk || this.isGermany || this.isDenmark || this.isUAE || this.isCanada || this.isSaudiArabia || this.isUSA)
        && !(this.isClientGateway || this.isNoPaymentGateway);
    },
    defaultPaymentSystem() {
      const preferred = COUNTRY_DEFAULT_PAYMENT_SYSTEM[this.form.country];

      // Never preselect an option the user cannot pick himself.
      return this.paymentSystems
        .find((system) => system.value === preferred && !system.disabled)?.value || null;
    },
    isGermany() {
      return this.form.country === 'de';
    },
    isDenmark() {
      return this.form.country === 'dk';
    },
    isUAE() {
      return this.form.country === 'ae';
    },
    isUk() {
      return this.form.country === 'gb';
    },
    isCanada() {
      return this.form.country === 'ca';
    },
    isSaudiArabia() {
      return this.form.country === 'sa';
    },
    isUSA() {
      return this.form.country === 'us';
    },
    showVenue() {
      return ((!this.isGermany && !this.isDenmark && !this.isUAE && !this.isUSA && !this.showGroups)
        || (this.form.tipsType && !this.venueDisabled))
        && !this.isTipPayoutEmployer;
    },
    showTimeSheet() {
      return this.isCommon
        && !this.isTipPayoutEmployer
        && !this.isCanada
        && !this.isSaudiArabia;
    },
    showStaffSortingMethod() {
      return this.form.paymentPage === PAYMENT_PAGE_TYPE.LIST || this.form.paymentPage === PAYMENT_PAGE_TYPE.GROUPS;
    },
    showTipout() {
      return this.isUk && (this.form.tipsType && !this.primaryStaffDisabled);
    },
    showPayoutDestination() {
      return (this.isUSA || this.isCanada || this.isUk || this.isGermany || this.isDenmark || this.isUAE)
        && this.isPersonal
        && this.form.payoutMethod === PAYOUT_METHOD.LOCAL;
    },
    showPaymentPage() {
      return (this.isPersonal || this.isMixed)
        && !this.isTipPayoutEmployer;
    },
    showTaxesSelect() {
      return !this.showCaseType
        && this.form.taxReportingType !== 'SELF_REPORTING'
        && !this.isGermany
        && !this.isDenmark
        && !this.isUAE
        && !this.isCanada
        && !this.isSaudiArabia
        && !this.isUSA;
    },
    showTaxReportingType() {
      return !this.showCaseType && this.isUk;
    },
    showGroups() {
      return this.form.paymentPage === 'GROUPS';
    },
    isSpaOrSalon() {
      return this.form.type === 'SPA'
        || this.form.type === 'BEAUTY_SALON';
    },
    isTrips() {
      return this.form.type === 'TRIPS';
    },
    isTaxesDisabled() {
      return this.form.taxReportingType === 'SELF_REPORTING'
        || !this.editable;
    },
    isSupportAdminEditable() {
      return this.editable || this.isSupportAdmin;
    },
    isTaxesRequired() {
      return this.form.taxReportingType === 'EMPLOYER';
    },
    taxesValidationRules() {
      return this.isTaxesRequired ? 'required' : '';
    },
    showMasterLocationSelect() {
      return this.form.type === 'HOTEL';
    },
    isMasterLocation() {
      return this.form.isMasterLocation;
    },
  },

  watch: {
    'form.country': {
      immediate: true,
      async handler(newValue, oldValue) {
        if (oldValue === 'gb' && newValue !== 'gb' && (this.isNoPaymentGateway)) {
          this.form.processingMethod = PROCESSING_METHOD.EASYTIP_LOCAL_GATEWAY;
          this.form.caseType = null;
          this.resetCase5PaymentFields();
        }

        const isOnlyOneType = !this.form.type && this.types.length === 1;
        const noSelectedTypeInCountry = this.form.type && !this.types.some((type) => type.value === this.form.type);

        if (isOnlyOneType || noSelectedTypeInCountry) {
          this.form.type = this.types[0].value;
        }

        if (newValue) {
          try {
            await this.getStaffTypes();
          } catch (e) {
            this.$showServerError(e);
          }
        }

        if (oldValue === 'gb') {
          this.form.taxReportingType = null;
          this.form.taxes = null;
        }

        if (!this.form.status) {
          this.resetPaymentSystem();
        }
      },
    },
    'form.type': {
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.form.tipsType = null;
          this.form.workplaceFee = null;
          this.form.primaryStaff = null;
          this.form.primaryTipout = 0;
          this.form.paymentPage = null;
          this.form.timesheetType = null;
          this.form.isMasterLocation = false;
          this.form.groups = [];
          this.form.sublocations = [];
          this.primaryStaffAuto();
          this.form.processingMethod = PROCESSING_METHOD.EASYTIP_LOCAL_GATEWAY;
          this.form.payoutMethod = PAYOUT_METHOD.LOCAL;
        }
      },
    },
    'form.processingMethod': {
      handler(value, oldValue) {
        if (value === PROCESSING_METHOD.NO_PAYMENT_GATEWAY) {
          this.resetCase5PaymentFields();
          this.clearPersonalTipsTypeForCase5Flow();
          this.syncCaseTypeWithAvailableOptions();

          return;
        }

        if (oldValue === PROCESSING_METHOD.NO_PAYMENT_GATEWAY) {
          this.form.caseType = null;
        }
      },
    },
    'form.caseType': {
      handler(caseType, oldCaseType) {
        if (caseType === CASE_TYPE.CASE_5) {
          this.form.processingMethod = PROCESSING_METHOD.NO_PAYMENT_GATEWAY;
          this.resetCase5PaymentFields();
          this.clearPersonalTipsTypeForCase5Flow();

          return;
        }

        if (oldCaseType === CASE_TYPE.CASE_5 && caseType !== CASE_TYPE.CASE_5) {
          this.form.processingMethod = PROCESSING_METHOD.EASYTIP_LOCAL_GATEWAY;
        }
      },
    },
    'form.tipsType': {
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.form.tipPayoutType = null;
          this.form.workplaceFee = null;
          this.form.primaryStaff = null;
          this.form.primaryTipout = 0;
          this.form.paymentPage = null;
          this.form.timesheetType = null;
          this.form.groups = [];
          this.form.sublocations = [];
          this.form.isTipOutEnabled = null;
          this.form.isHouseTipOuts = null;
          this.form.isDetailedTransactionBreakdown = null;
          this.form.isContributorsTeamDistribution = null;
          this.primaryStaffAuto();

          if ((this.isUAE || this.isUSA) && !this.isPersonal && !this.isClientGateway) {
            this.form.tipPayoutType = 'INDIVIDUAL';
          }

          if (this.showTimeSheet && this.isCommonSimple) {
            this.form.timesheetType = 'HOURS';
          }

          if (newValue !== 'PERSONAL') {
            this.form.payoutDestination = null;
          }

          if (this.isNoPaymentGateway && !this.isCommon && !this.isMixed) {
            this.form.caseType = null;
          }

          this.resetPaymentSystem();
        }
      },
    },
    showPayoutDestination(value) {
      if (!value) {
        this.form.payoutDestination = null;

        return;
      }

      if (!this.form.payoutDestination) {
        this.form.payoutDestination = PAYOUT_DESTINATION.INDIVIDUAL;
      }
    },
    showPaymentSystem() {
      this.resetPaymentSystem();
    },
    'form.paymentPage': {
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.form.groups = [];
        }
      },
    },
    'form.tipPayoutType': {
      handler(value) {
        if (value === 'INDIVIDUAL') {
          this.form.paymentSystem = PAYMENT_SYSTEM.PAYER_MAX;
        } else if (value === 'EMPLOYER') {
          this.form.paymentSystem = PAYMENT_SYSTEM.STRIPE;
        }
      },
    },
    'form.paymentSystem': {
      handler(value) {
        if (value !== PAYMENT_SYSTEM.RYFT && this.form.caseType !== CASE_TYPE.CASE_5) {
          this.form.caseType = null;
        }
      },
    },
    'form.enableTapToTip': {
      handler(value) {
        if (value) {
          this.form.abVariant = AB_VARIANTS_TYPES.DESIGN_TWO_BUTTON_TWO_CAPTION;
        }
      },
    },
    'form.taxes': {
      handler() {
        this.form.caseType = null;
      },
    },
    showStaffSortingMethod(value) {
      if (!value) {
        this.form.staffSortingMethod = 'RANDOM';
      }
    },
    showPaymentPage(value) {
      if (!value) {
        this.form.paymentPage = null;
      }
    },
    showCaseType(value) {
      if (value) {
        this.form.taxes = null;
        this.form.taxReportingType = null;
      } else if (!this.isCase5) {
        this.form.caseType = null;
      }
    },
    showVenue(value) {
      if (!value) {
        this.form.workplaceFee = null;
      }
    },
    venueDisabled() {
      this.form.workplaceFee = null;
    },
    showTipout(value) {
      if (!value) {
        this.form.primaryStaff = null;
        this.form.primaryTipout = 0;
      }

      this.primaryStaffAuto();
    },
    primaryStaffDisabled() {
      this.form.primaryStaff = null;
      this.primaryStaffAuto();
    },
    isCommon(value) {
      if (!value) {
        this.form.timesheetType = null;
      }
    },
  },

  methods: {
    ...mapActions('handbook', [
      'getStaffTypes',
    ]),
    handleSublocationsUpdate(payload) {
      this.form.sublocations = payload;
    },
    handleUpdateGroups(payload) {
      this.form.groups = payload;
    },
    syncCaseTypeWithAvailableOptions() {
      const availableCaseTypes = this.caseTypes
        .filter(({ disabled }) => !disabled)
        .map(({ value }) => value);

      if (this.form.caseType && !availableCaseTypes.includes(this.form.caseType)) {
        this.form.caseType = null;
      }
    },
    primaryStaffAuto() {
      if (!this.showTipout || this.primaryStaffDisabled) {
        return;
      }

      const values = this.staffTypes.map(({ value }) => value);

      if (values.includes(this.form.primaryStaff)) {
        return;
      }

      if (values.length === 1) {
        [this.form.primaryStaff] = values;
      } else {
        this.form.primaryStaff = null;
      }
    },
    resetCase5PaymentFields() {
      this.form.paymentSystem = null;
      this.form.payoutMethod = null;
    },
    clearPersonalTipsTypeForCase5Flow() {
      if (this.form.tipsType === 'PERSONAL') {
        this.form.tipsType = null;
      }
    },
    resetPaymentSystem() {
      if (!this.showPaymentSystem) {
        this.form.paymentSystem = null;

        return;
      }

      const current = this.paymentSystems.find((system) => system.value === this.form.paymentSystem);

      if (!current || current.disabled) {
        this.form.paymentSystem = this.defaultPaymentSystem;
      }
    },
  },
};
</script>
